import { Controller } from "@hotwired/stimulus";
import { scrollBelowHeader } from "~/lib/scroll";

// In-page anchor link (e.g. "to checkout" on carts/current) that glides to its
// #target instead of jumping there, stopping below the sticky header like the
// course search filter button does.
export default class extends Controller {
  scroll(event) {
    const target = document.querySelector(this.element.getAttribute("href"));
    if (!target) return;
    event.preventDefault();
    scrollBelowHeader(target);
  }
}
